import { render } from "./StrategyDock.vue?vue&type=template&id=e7b78270"
import script from "./dock.js?vue&type=script&lang=js&external"
export * from "./dock.js?vue&type=script&lang=js&external"

import "./dock.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__